<template>
  <div class="styleCard">
    <ul class="style-nav style2">
      <li
        v-for="tab in repTabs"
        :key="tab.id"
        :class="{ active: selectedRepTab === tab.alias }"
        @click="selectedRepTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <ul class="style-nav style2">
      <li
        v-for="tab in repSecondTabs"
        :key="tab.id"
        :class="{ active: selectedRepTab === tab.alias }"
        @click="selectedRepTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <ul class="style-nav style2">
      <li
        v-for="tab in repTimeTabs"
        :key="tab.id"
        :class="{ active: selectedRepTab === tab.alias }"
        @click="selectedRepTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <scheduled-calls-status
      v-if="selectedRepTab === 'CA_STATUS'"
    ></scheduled-calls-status>
    <scheduled-calls-auto-status
      v-if="selectedRepTab === 'CA_AUTO_STATUS'"
    ></scheduled-calls-auto-status>
    <no-answer v-if="selectedRepTab === 'NA_STATS'"></no-answer>
    <transferred-to v-if="selectedRepTab === 'TRANSFERRED_TO'"></transferred-to>
    <transferred-to-live
      v-if="selectedRepTab === 'TRANSFERRED_TO_LIVE'"
    ></transferred-to-live>
    <transferred-to-online
      v-if="selectedRepTab === 'TRANSFERRED_TO_ONLINE'"
    ></transferred-to-online>
    <not-interested-lead
      v-if="selectedRepTab === 'NI_LEAD'"
    ></not-interested-lead>
    <not-interested-reason
      v-if="selectedRepTab === 'NI_REASON'"
    ></not-interested-reason>
    <bad-number-reason
      v-if="selectedRepTab === 'BN_REASON'"
    ></bad-number-reason>
    <keyword v-if="selectedRepTab === 'KEYWORD'"></keyword>
    <campaign v-if="selectedRepTab === 'CAMPAIGN'"></campaign>
    <deposits v-if="selectedRepTab === 'DEPOSITS'"></deposits>
    <brokers v-if="selectedRepTab === 'BROKERS'"></brokers>
    <second-voice v-if="selectedRepTab === 'SEC_VOICE'"></second-voice>
    <not-reached v-if="selectedRepTab === 'NR'"></not-reached>
    <registrations v-if="selectedRepTab === 'REGISTRATIONS'"></registrations>
    <assigned-agents
      v-if="selectedRepTab === 'ASSIGNED_AGENTS'"
    ></assigned-agents>
    <!--    <assigned-agents-conversion-->
    <!--      v-if="selectedRepTab === 'ASSIGNED_AGENTS_CONVERSION'"-->
    <!--    ></assigned-agents-conversion>-->
    <!--    <pro-club v-if="selectedRepTab === 'PRO_CLUB'"></pro-club>-->
    <cc-decline v-if="selectedRepTab === 'CC_DECLINE'"></cc-decline>
    <daily-report v-if="selectedRepTab === 'DAILY'"></daily-report>
  </div>
</template>

<script>
import ScheduledCallsStatus from "../scheduledCallsStatus.stats/containers/ScheduledCallsStatus.container";
import ScheduledCallsAutoStatus from "../scheduledCallsAutoStatus.stats/containers/ScheduledCallsAutoStatus.container";
import NoAnswer from "../noAnswer.stats/containers/NoAnswer.container";
import TransferredTo from "../transferredTo.stats/containers/TransferredTo.container";
import NotInterestedLead from "../notInterestedLead.stats/containers/NotInterestedLead.container";
import Deposits from "../deposits.stats/containers/Deposits.container";
import NotInterestedReason from "../notInterestedReason.stats/containers/NotInterestedReason.container";
import BadNumberReason from "../badNumberReason.stats/containers/BadNumberReason.container";
import Keyword from "../keyword.stats/containers/Keyword.container";
import Campaign from "../campaign.stats/containers/Campaign.container";
import Brokers from "../brokers.stats/containers/Brokers.container";
import SecondVoice from "../secondVoice.stats/containers/SecondVoice.container";
import NotReached from "../notReached.stats/containers/NotReached.container";
import Registrations from "../registrations.stats/containers/Registrations.container";
import AssignedAgents from "../assignedAgents.stats/containers/AssignedAgents.container";
import AssignedAgentsConversion from "../assignedAgentsConversion.stats/containers/AssignedAgentsConversion.container";
import TransferredToLive from "../transferredToLive.stats/containers/TransferredToLive.container";
import TransferredToOnline from "../transferredToOnline.stats/containers/TransferredToOnline.container";
import DailyReport from "../dailyReport.stats/containers/DailyReport.container";
import ProClub from "../proClub.stats/containers/ProClub.container";
import CcDecline from "../ccDecline.stats/containers/CcDecline.container";

export default {
  name: "Stats.container",

  components: {
    CcDecline,
    // ProClub,
    DailyReport,
    TransferredToOnline,
    TransferredToLive,
    // AssignedAgentsConversion,
    AssignedAgents,
    Registrations,
    NotReached,
    SecondVoice,
    Brokers,
    Campaign,
    Keyword,
    BadNumberReason,
    NotInterestedReason,
    ScheduledCallsAutoStatus,
    Deposits,
    NotInterestedLead,
    TransferredTo,
    NoAnswer,
    ScheduledCallsStatus
  },
  data() {
    return {
      selectedRepTab: "",
      repTabs: [
        {
          id: 0,
          name: "Scheduled Calls Status",
          alias: "CA_STATUS"
        },
        {
          id: 1,
          name: "Scheduled Calls Auto Status",
          alias: "CA_AUTO_STATUS"
        },
        {
          id: 2,
          name: "No Answer Agents",
          alias: "NA_STATS"
        },
        {
          id: 3,
          name: "Transferred To",
          alias: "TRANSFERRED_TO"
        },
        {
          id: 4,
          name: "Transferred To Live",
          alias: "TRANSFERRED_TO_LIVE"
        },
        {
          id: 5,
          name: "Transferred To Online",
          alias: "TRANSFERRED_TO_ONLINE"
        },
        {
          id: 6,
          name: "Not Interested Lead",
          alias: "NI_LEAD"
        },
        {
          id: 7,
          name: "Not Interested Reasons",
          alias: "NI_REASON"
        },
        {
          id: 8,
          name: "Bad Number Reasons",
          alias: "BN_REASON"
        },
        {
          id: 9,
          name: "CC - Decline deposits",
          alias: "CC_DECLINE"
        }
      ],
      repSecondTabs: [
        {
          id: 0,
          name: "Keywords",
          alias: "KEYWORD"
        },
        {
          id: 1,
          name: "Campaigns",
          alias: "CAMPAIGN"
        },
        {
          id: 2,
          name: "Deposits",
          alias: "DEPOSITS"
        },
        {
          id: 3,
          name: "Brokers",
          alias: "BROKERS"
        },
        {
          id: 4,
          name: "Second Voice",
          alias: "SEC_VOICE"
        },
        {
          id: 5,
          name: "Not Reached",
          alias: "NR"
        },
        {
          id: 6,
          name: "Registrations",
          alias: "REGISTRATIONS"
        },
        {
          id: 7,
          name: "Assigned Agents",
          alias: "ASSIGNED_AGENTS"
        }
      ],
      repTimeTabs: [
        {
          id: 0,
          name: "Daily Report",
          alias: "DAILY"
        }
      ]
    };
  }
};
</script>

<style scoped>
.root {
  width: 90%;
  margin: auto;
}
.card-body {
  padding: 10px;
}
.card-header {
  border-bottom: 1px solid rgba(10, 10, 10, 0.1);
}
.td-users-ms {
  width: 100px;
}
.floating-wrapper {
  position: relative;
}
.w50 {
  width: calc(50% - 0.2rem);
}
.left {
  float: left;
}
.margin {
  margin: 0.5rem;
}
.margin_r_hf {
  margin-right: 0.2rem;
}
.margin_l_c {
  margin-left: 0;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: max-content;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 100px;
  right: 0;
  left: 0;
  width: 99%;
  font-family: Montserrat;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
			background: white;
		      */
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(4px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
  /* transform: translateY(4px);*/
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.form-body {
  padding: 20px;
  background-color: white;
}
.form-body form {
  margin-bottom: 20px;
}
.bttn {
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}
</style>
